/**
 * SkillEditorPage Component
 *
 * Wraps the workflow editor in skill mode.
 */

import React from 'react';
import { WorkflowEditorPage } from '@/modules/workflows/pages/WorkflowEditorPage';

export const SkillEditorPage: React.FC = () => {
  return <WorkflowEditorPage mode="skill" />;
};

export default SkillEditorPage;
